import { useState } from 'react';
import './WhatWeSellCarousel.css';

const INTERVAL = 3000;

const WhatWeSellCarousel = ({ items }) => {
  const [active, setActive] = useState(0);
  const [key, setKey] = useState(0);

  const goTo = (index) => {
    setActive(index);
    setKey((k) => k + 1);
  };

  const advance = () => {
    setActive((a) => (a + 1) % items.length);
    setKey((k) => k + 1);
  };

  const { icon, title, desc } = items[active];

  return (
    <div className="wws-carousel">
      <div className="wws-slide">
        <span className="material-symbols-outlined wws-icon">{icon}</span>
        <p className="wws-title">{title}</p>
        {desc && <p className="wws-desc">{desc}</p>}
      </div>

      <div className="wws-dots">
        {items.map((_, i) => (
          <button
            key={i}
            className={`wws-dot ${i === active ? 'wws-dot--active' : ''}`}
            onClick={() => goTo(i)}
            aria-label={`Go to item ${i + 1}`}
          >
            {i === active && (
              <span
                key={key}
                className="wws-dot-fill"
                style={{ animationDuration: `${INTERVAL}ms` }}
                onAnimationEnd={advance}
              />
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default WhatWeSellCarousel;
